module.exports = __webpack_public_path__ + "img/Logo-Horizontal-Blanco.6734b3ac.png";